import Model from 'flarum/common/Model';
export default class Exhibition extends Model {
  name() {
    return Model.attribute('name').call(this);
  }

  // Plain "YYYY-MM-DD" strings, not Date objects - see formatDate.ts's own
  // docblock for why these are deliberately never run through
  // Model.transformDate.
  startDate() {
    return Model.attribute('startDate').call(this);
  }
  endDate() {
    return Model.attribute('endDate').call(this);
  }
  location() {
    return Model.attribute('location').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }

  // Comma-separated species-group keys (e.g. "fungi,myxo") restricting
  // ExhibitionFindingEditModal's own species search - see
  // ExhibitionResource::fields()'s own speciesGroups docblock. Empty
  // string means unrestricted.
  speciesGroups() {
    return Model.attribute('speciesGroups').call(this);
  }

  // A "Comestibilité" column in its Excel/PDF exports - see
  // ExhibitionResource::fields().
  exportToxicity() {
    return Model.attribute('exportToxicity').call(this);
  }
  groupId() {
    return Model.attribute('groupId').call(this);
  }

  // Only on the one exhibition requested: its species in its société's
  // cards' order, by phylum (sort=phylum) - see Exhibition::sortsByPhylum().
  sortsByPhylum() {
    return Model.attribute('sortsByPhylum').call(this);
  }

  // Only on the one exhibition requested - whether the public page offers
  // the sort by number (and starts with it), and its slideshow.
  hasNumberedFindings() {
    return Model.attribute('hasNumberedFindings').call(this);
  }
  hasFindingPhotos() {
    return Model.attribute('hasFindingPhotos').call(this);
  }
  findingsCount() {
    return Model.attribute('findingsCount').call(this);
  }

  // Only on the one exhibition requested, not in lists - see
  // ExhibitionResource's societyName field.
  societyName() {
    return Model.attribute('societyName').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  findings() {
    return Model.hasMany('findings').call(this);
  }
}
flarum.reg.add('champis-exhibitions', 'common/models/Exhibition', Exhibition);